import { useEffect, useState } from 'react';
import { getAdicionaisAdmin, criarAdicional, atualizarAdicional, deletarAdicional } from '../../services/api';

export default function AdminAdicionais() {
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ nome: '', preco: '', emoji: '➕', ordem: 0, ativo: 1 });

  const carregar = () => {
    setLoading(true);
    getAdicionaisAdmin().then(r => setLista(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { carregar(); }, []);

  const abrirNovo = () => {
    setEditando('novo');
    setForm({ nome: '', preco: '', emoji: '➕', ordem: lista.length + 1, ativo: 1 });
  };

  const abrirEditar = (item) => {
    setEditando(item.id);
    setForm({
      nome: item.nome,
      preco: item.preco,
      emoji: item.emoji || '➕',
      ordem: item.ordem || 0,
      ativo: item.ativo
    });
  };

  const cancelar = () => {
    setEditando(null);
    setForm({ nome: '', preco: '', emoji: '➕', ordem: 0, ativo: 1 });
  };

  const salvar = async () => {
    if (!form.nome || form.preco === '') {
      alert('Preencha nome e preço');
      return;
    }
    try {
      const dados = {
        nome: form.nome,
        preco: parseFloat(form.preco),
        emoji: form.emoji || '➕',
        ordem: parseInt(form.ordem) || 0,
        ativo: form.ativo ? 1 : 0
      };
      if (editando === 'novo') {
        await criarAdicional(dados);
      } else {
        await atualizarAdicional(editando, dados);
      }
      cancelar();
      carregar();
    } catch (err) {
      alert('Erro: ' + (err.response?.data?.error || err.message));
    }
  };

  const desativar = async (item) => {
    if (!window.confirm(`Desativar "${item.nome}"?`)) return;
    try {
      await deletarAdicional(item.id);
      carregar();
    } catch (err) {
      alert('Erro: ' + (err.response?.data?.error || err.message));
    }
  };

  if (loading) return <div style={{ padding: 16 }}><div className="spinner" /></div>;

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2>➕ Adicionais</h2>
        {!editando && (
          <button onClick={abrirNovo} style={{
            background: 'linear-gradient(90deg,var(--red),var(--orange))',
            border: 'none', color: '#fff', padding: '10px 18px', borderRadius: 8,
            cursor: 'pointer', fontWeight: 800, fontFamily: 'Nunito,sans-serif'
          }}>+ Novo Adicional</button>
        )}
      </div>

      {editando && (
        <div style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 10, padding: 16, marginBottom: 16 }}>
          <h3 style={{ marginBottom: 12 }}>{editando === 'novo' ? '➕ Novo Adicional' : '✏️ Editando'}</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '80px 1fr 120px 80px', gap: 10, marginBottom: 12 }}>
            <div>
              <label style={{ fontSize: 11, color: 'var(--text2)' }}>Emoji</label>
              <input type="text" value={form.emoji} onChange={e => setForm({ ...form, emoji: e.target.value })}
                maxLength={2} style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 11, color: 'var(--text2)' }}>Nome*</label>
              <input type="text" value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })}
                placeholder="Ex: Bacon" style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 11, color: 'var(--text2)' }}>Preço (R$)*</label>
              <input type="number" step="0.50" value={form.preco} onChange={e => setForm({ ...form, preco: e.target.value })}
                placeholder="0.00" style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 11, color: 'var(--text2)' }}>Ordem</label>
              <input type="number" value={form.ordem} onChange={e => setForm({ ...form, ordem: e.target.value })}
                style={inputStyle} />
            </div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
              <input type="checkbox" checked={!!form.ativo} onChange={e => setForm({ ...form, ativo: e.target.checked ? 1 : 0 })} />
              Ativo (visível no carrinho)
            </label>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={salvar} style={{
              background: '#2ea82e', border: 'none', color: '#fff', padding: '10px 18px', borderRadius: 8,
              cursor: 'pointer', fontWeight: 800, fontFamily: 'Nunito,sans-serif'
            }}>💾 Salvar</button>
            <button onClick={cancelar} style={{
              background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text2)',
              padding: '10px 18px', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontFamily: 'Nunito,sans-serif'
            }}>Cancelar</button>
          </div>
        </div>
      )}

      {!lista.length ? (
        <div className="empty-state"><div className="icon">➕</div><p>Nenhum adicional cadastrado</p></div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {lista.map(item => (
            <div key={item.id} style={{
              display: 'flex', alignItems: 'center', gap: 12, padding: 12,
              background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 8,
              opacity: item.ativo ? 1 : 0.5
            }}>
              <span style={{ fontSize: 24 }}>{item.emoji || '➕'}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700 }}>{item.nome}</div>
                <div style={{ fontSize: 11, color: 'var(--text2)' }}>
                  Ordem: {item.ordem} {!item.ativo && '• ⚠️ INATIVO'}
                </div>
              </div>
              <div style={{ fontWeight: 800, color: 'var(--orange)', fontSize: 16 }}>
                R$ {parseFloat(item.preco).toFixed(2).replace('.', ',')}
              </div>
              <button onClick={() => abrirEditar(item)} style={{
                background: 'var(--bg4)', border: '1px solid var(--border)', color: 'var(--text)',
                padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'Nunito,sans-serif'
              }}>✏️ Editar</button>
              {item.ativo === 1 && (
                <button onClick={() => desativar(item)} style={{
                  background: 'rgba(230,48,48,.15)', border: '1px solid var(--red)', color: 'var(--red)',
                  padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'Nunito,sans-serif'
                }}>🗑️</button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const inputStyle = {
  width: '100%', padding: '8px 10px', borderRadius: 6,
  border: '1px solid var(--border)', background: 'var(--bg4)',
  color: 'var(--text)', fontSize: 13, fontFamily: 'Nunito,sans-serif',
  marginTop: 2
};
